import React from 'react';

export const SectionHeading = ({ heading: { html }, className }) => (
  <div className={`offer-room-content-title ${className}`} dangerouslySetInnerHTML={{ __html: html }} />
);
